module.exports = __webpack_public_path__ + "img/puzzle2.jpg";